import { requestsLikeGenerate } from "../../../plugins/python/requestsLike.js";
const pythonRequests = {
  target: "python",
  client: "requests",
  title: "Requests",
  generate(request, configuration) {
    return requestsLikeGenerate("requests", request, configuration);
  }
};
export {
  pythonRequests
};
//# sourceMappingURL=requests.js.map
